export default __webpack_public_path__ + "static/23-d7e3b6c69011506f9f33f1a594c36017.webp";